import request_api from "../../core/request_api";
import Swal from "sweetalert2";

const state = {
  dataCountry: [],
  // dataState: [],
  // dataCity: [],
};
const getters = {
  getCountry:(state) =>{
    return state.dataCountry;
  }
  // getState(state) {
  //   return state.dataState;
  // },
  // getCity(state) {
  //   return state.dataCity;
  // },
};
const mutations = {
  LOAD_COUNTRY(state, payload) {
    return (state.dataCountry = payload);
  }
  // LOAD_STATE(state, payload) {
  //   return (state.dataState = payload);
  // },
  // LOAD_CITY(state, payload) {
  //   return (state.dataCity = payload);
  // },
};
const actions = {
  loadCountry({ commit }) {
    request_api()
      .get("master/country/dropdown")
      .then((res) => {
        const meta = res.data;
        if (meta.code === 200) {
          // commit("LOAD_STATE", [])
          // commit("LOAD_CITY", []);
          commit("LOAD_COUNTRY", meta.data);
        }
      })
      .catch((err) => {
        // console.log(err)
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.response.data.message,
        });
      });
  }
  // loadState({ commit }, data) {
  //   request_api()
  //     .get(`master/state/dropdown?country=${data}`)
  //     .then((res) => {
  //       const meta = res.data;
  //       if (meta.code === 200) {
  //         commit("LOAD_CITY", []);
  //         commit("LOAD_STATE", meta.data);
  //       }
  //     })
  //     .catch((err) => {
  //       // console.log(err)
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: err.response.data.message,
  //       });
  //     });
  // },
  // loadCity({ commit }, data) {
  //   request_api()
  //     .get(`master/city/dropdown?state=${data}`)
  //     .then((res) => {
  //       const meta = res.data;
  //       if (meta.code === 200) {
  //         commit("LOAD_CITY", meta.data);
  //       }
  //     })
  //     .catch((err) => {
  //       // console.log(err)
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: err.response.data.message,
  //       });
  //     });
  // },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
